import { HttpContextToken } from '@angular/common/http';
import { computed, Injectable, signal } from '@angular/core';

export const SHOW_LOADER = new HttpContextToken<boolean>(() => true);

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private _loading = signal(false);

  loading = computed(() => this._loading());

  show() {
    this._loading.set(true);
  }

  hide() {
    this._loading.set(false);
  }
}
